import { ROOT_ADMIN, SUPER_ADMIN } from 'utils/constants';

const isSuperAdminOrAbove = (authorizationLevel) => {
  return (
    authorizationLevel === SUPER_ADMIN || authorizationLevel === ROOT_ADMIN
  );
};

export default isSuperAdminOrAbove;
